"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentLoopBody = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var ContentLoopBody = (0, mobx_react_1.observer)(function (props) {
    var children = props.children;
    return (react_1.default.createElement("div", { className: "content-loop-widget__body", contentEditable: true, suppressContentEditableWarning: true }, children));
});
exports.ContentLoopBody = ContentLoopBody;
